<template>
  <div class="main">
    <component
      v-if="loadStatus === 1"
      :is="pageType"
      :fund-code="fundCode"
      ref="actualPage"
      class="fund-detail-page"
    />
    <!-- 加载失败 && 加载中 -->
    <div v-else>
      <img v-if="loadStatus === 0" :src="LOADING" class="loading" />
      <div v-else class="err-box">
        <img :src="ERR_IMG" class="err-img" />
        <div>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import ERR_IMG from '@/assets/NS-004.png';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { getUrlParams } from '@fund/basic-lib/dist/lib/qs';
import DefaultPage from './pages/defaultPage.vue';
import DetailPage from './pages/detail/index.vue';
import errorPage from './pages/errorPage.vue';
import HighEnd from './pages/highend-detail/index.vue';
import HK from './pages/hk.vue';

export default {

  name: 'detail-page',

  components: {
    DefaultPage,
    HighEnd,
    errorPage,
    DetailPage,
    HK,
  },

  data() {
    return {
      fundCode: '',
      pageType: '',
      loadStatus: 0, // 加载状态 0-加载中，1-加载完成，-1-加载失败
      LOADING: 'https://j5.dfcfw.com/sc/image/202006/20200622011833.gif',
      ERR_IMG,
    };
  },

  created() {
    this.pageType = 'DefaultPage';
    const urlParams = getUrlParams();
    this.fundCode = urlParams?.fCode?.toString();
    // 获取动态路由配置
    this.getWxJumpConfig();
  },

  async mounted() {
    try {
      const res = await this.$http.useRequests('FundComApi.getFundStopWatchList', this.fundCode);
      const temp = res?.find((item) => item.fundCode === this.fundCode);
      if (!temp) {
        this.loadStatus = 0;
      } else {
        this.loadStatus = 1;
        if (temp.pageType === 'public-offer-fund') {
          this.pageType = 'DetailPage';
        } else if (temp.pageType === 'high-end-fund') {
          this.pageType = 'HighEnd';
        } else if (temp.pageType === 'hong-kong-fund') {
          this.pageType = 'HK';
        } else {
          this.pageType = 'DetailPage';
        }
      }
    } catch (error) {
      this.loadStatus = -1;
    }
  },

  methods: {
    async getWxJumpConfig() {
      // 判断环境&是否有缓存
      const isProd = window.location.hostname.indexOf('test') === -1;
      console.log('环境>', isProd ? '正式' : '测试', 'host>', window.location.hostname);
      const storage = window.localStorage.getItem('wxjumpconfig');
      // 有缓存&没过期（30分钟）就拿缓存，否则调接口
      if (!isEmpty(storage) && storage.timeStamp < new Date().getTime() - 30 * 60 * 1000) {
        return;
      }
      const res = await this.$http.useRequests('ConfigApi.getWxJumpConfig', !isProd);
      // 存缓存
      window.localStorage.setItem(`wxjumpconfig-${isProd ? 'prod' : 'test'}`, JSON.stringify({
        content: res?.datas?.content,
        timeStamp: new Date().getTime(),
      }));
    },
  },

};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  width: 100%;
  touch-action: pan-y;

  .loading {
    height: 100px;
    width: 440px;
    margin-top: calc(50% - 50px);
    margin-left: calc(50% - 220px);
  }

  .err-box {
    margin-top: calc(50% - 226px);
    font-size: 30px;
    color: #999999;
    text-align: center;

    .err-img {
      height: 400px;
    }
  }
}

#detail-page {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.fund-detail-all {
  height: 100%;
  width: 100%;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
